import { render, staticRenderFns } from "./SidebarItemNew.vue?vue&type=template&id=5e3d6a4c&scoped=true&"
import script from "./SidebarItemNew.vue?vue&type=script&lang=js&"
export * from "./SidebarItemNew.vue?vue&type=script&lang=js&"
import style0 from "./SidebarItemNew.vue?vue&type=style&index=0&id=5e3d6a4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3d6a4c",
  null
  
)

export default component.exports